export const DELETED = Symbol('ENTITY WAS DELETED');
